/*
* Created on Oct 21, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, {useEffect} from 'react';
import {useTranslation} from "react-i18next";
import {useAuthService} from "../../hook/AuthServiceHook";
import {useCookiesSettings} from "../../context/CookiesSettingContext";
import {useRegion} from "../../context/RegionContext";
import {convertToQNAPLang} from "../../service/common";

const CookiesManagerComponent = ({showManager, setShowManager, setShowDialog}) => {
    const {t, i18n} = useTranslation();
    const {url, region} = useRegion();
    const {AUTHAPI} = useAuthService();
    const {get_cookies_settings} = useCookiesSettings()

    const accept_all = () => {
        AUTHAPI.set_cookies({is_cookies_set: true, FC: true, AC: true, SC: true});
        setShowManager(false);
    }

    const open_settings = (event) => {
        event.preventDefault();
        setShowDialog(true);
    }

    // useEffect(()=>{
    //     get_cookies_settings();
    // });

    return (
        <>
            { showManager &&
                <div className="cookies-manager">
                    <div className="manager-info">
                        <div className="!mb-10"
                             dangerouslySetInnerHTML={{
                                 __html: t('@By clicking "Accept all", you agree to the storing of cookies on your device to enhance your browsing experiences and to provide our services, as detailed in our {privacy_policy}.@')
                                     .replace("{privacy_policy}", `<a href='${url.get_qnap_url()}/${region === 'CHINA' ? 'zh-cn' : 'go'}/legal/qnap-privacy-policy' target="_blank">${t('@Privacy policy@')}</a>`)
                             }}
                        >
                        </div>
                        <div>
                            {t('@You can select Manage settings for more information and to manage your choices. You can change your choices at any time.@')}
                        </div>
                    </div>
                    <div className="manager-action">
                        <button type="button" className="q-btn q-btn-primary" onClick={accept_all}>{t('@Accept all@')}</button>
                        <div className="!mt-16"><a href="#" onClick={e=>open_settings(e)}>{t('@Manage settings@')}</a></div>
                    </div>
                </div>
            }
        </>
    );
};

export default CookiesManagerComponent;